export class ValidationResponse extends Error {
  constructor({ resolvedFields, rejectedFields }) {
    super();    
    this.name = "ValidationResponse";
    this.resolvedFields = resolvedFields?resolvedFields:[];
    this.rejectedFields = rejectedFields?rejectedFields:[];
  }
}